import logo from './logo.svg';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import Header from './components/Header';
import CardsDetails from './components/CardsDetails';
import Cards from './components/Cards';
import {Routes,Route} from "react-router-dom";
import Home from './components/Home';
import About from './components/About';

function App() {
  document.title="Queen Resturant"
  return (
  <>
   <Header />
   <Routes>
     <Route path='/' element={<Home />} />
     <Route path='/about' element={<About />} />
     <Route path='/menu' element={<Cards />} />
     <Route path='/cart/:id' element={<CardsDetails />} />
    
   </Routes>
  </>
  );
}

export default App;
